/* @ngInject */
const autocompleteRequest = (
  $q,
  autocompleteResource,
  utils,
  valueHandler,
  $filter,
  errorHandler
) => {
  const self = {}

  self.get = async (field, nature, search = {}) => {
    return $q((resolve, reject) => {
      const functionName = '$autocomplete.get'

      if (valueHandler.isString(nature)) {
        if (!nature.match('s$')) {
          nature += 's'
        }
      }

      const data = {
        field,
        nature,
        search,
      }

      autocompleteResource.post({ search: true, }, data, (res) => {
        if (res && res.success) {
          const autocomplete = []
          utils.forEach(res.data, (auto) => {
            const formatedAuto = $filter('field')(auto, field)
            autocomplete.push(formatedAuto)
          })
          resolve(autocomplete)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 42) {
            console.error(functionName + ' This parameters doesn\'t exist in database : ' + nature + '.' + field)
          } else {
            errorHandler.message(res, functionName, data)
          }
          reject('Impossible de rechercher les éléments pour l\'autocomplétion')
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject('Connection avec le serveur impossible')
      })
    })
  }

  return self
}

export default autocompleteRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/autocomplete/services/request.service.js